// extracted by mini-css-extract-plugin
module.exports = {"body":"zYy0V","left-part":"AQ0Qt","right":"rBaEQ","description":"sfSLO"};